<!-- 养分选择表 -->
<template>
  <a-modal title="养分选择表"
    :visible="visible.nutChoose" 
    @ok="ok" 
    @cancel="cancel"
    :bodyStyle="tableStyle"
    :footer="showFooter"
    width="900px">
      <a-table
        :columns="columns"
        :loading="nutLoading"
        :data-source="list.records"
        :row-key="record => record.id"
        :scroll="{ x:0, y: 500 }"
        :pagination="false"
        :rowClassName="rowClassname"
        @change="listChange"
      >
        <template slot="option" slot-scope="text,record">
          <a type="link" @click="applyNutrition(record)" size="small">应用</a>
          <a-divider type="vertical"></a-divider>
          <a type="link" @click="viewNatrition(record)" size="small">查看</a>
        </template>
      </a-table>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils'
export default {
  props:['hidden'],
  mixins:[nhfMixins],
  data(){
    return{
      nutLoading:false,
      filterData:{},
      list:{},
      showFooter:false,
      tableStyle:{
        padding:'10px'
      },
      columns:[
        {
          title:"指标名称",
          dataIndex:"name",
          width:300
        },
        {
          title:"代码",
          dataIndex:"code",
          align:"center"
        },
        {
          dataIndex:'option',
          width: 150,
          title:"操作",
          align:'center',
          scopedSlots: {customRender: 'option'}
        }
      ]
    }
  },
  watch:{
    visible(val){
      if(val.nutChoose) this.getList()
    }
  },
  methods:{
    rowClassname(record){
      return record.id === this.detail.linkId ? 'selectRow': ''
    },
    ok(){
      this.filterData = {}
      this.$emit('ok',this.selectedRows)
      this.cleanSelect()
    },
    cancel(){
      this.filterData = {}
      this.cleanSelect()
      this.$emit('cancel')
    },
    applyNutrition(record){
      this.$confirm({
        title: '提示',
        content: '确认应用当前营养指标？',
        okText: '继续',
        cancelText: '取消',
        onOk: async () =>{
          this.$emit('ok',[record])
        },
        onCancel(){},
      })
    },

    viewNatrition(item){
      this.$emit('view',item)
    },
    
    getList(arg ={}){
      this.fetchGet({
        actions:this.animalNutritionUserPage,
        name:'list',
        loading:'nutLoading',
        isList:true,
        data:{
          ...arg,
          size:1000
        }
      })
    },
    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
  }
}
</script>
<style>
.ant-table-row-cell-break-word{
  position: relative !important;
}
.selectRow{
  background:#E9F6FE !important;
}
</style>
